export default __webpack_public_path__ + "static/media/course-summary-header-bg.fabb5d29.png";